interface Period {
  firstDate: Date | string | number | null;
  lastDate: Date | string | number | null;
}

// Purpose: find and return the overlap period for the 2 provided periods
// Example: period1: { firstDate: 2023.01.04, lastDate: 2023.09.14 }
//          period1: { firstDate: 2023.07.01, lastDate: 2023.12.31 }
//          result: { firstDate: 2023.07.01, lastDate: 2023.09.14 }
//

export const getIntersectingPeriod = function (
  period1: Period,
  period2: Period
): Period | null {
  if (!period1 || !period2 || !period1.firstDate || !period2.firstDate) {
    return null;
  }

  const firstDate = new Date(
    Math.max(
      new Date(period1.firstDate).getTime(),
      new Date(period2.firstDate).getTime()
    )
  );
  const lastDate = new Date(
    Math.min(
      (period1.lastDate ? new Date(period1.lastDate) : new Date()).getTime(),
      (period2.lastDate ? new Date(period2.lastDate) : new Date()).getTime()
    )
  );

  if (firstDate.getTime() > lastDate.getTime()) {
    return null;
  }

  // // CONSOLE LOG
  // console.log("getIntersectingPeriod");
  // console.log(" period1=", period1);
  // console.log(" period2=", period2);
  // console.log(" intersection=", { start, end });
  // console.log("/getIntersectingPeriod");

  return { firstDate, lastDate };
};
